import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 5h4v14h-4z",
  opacity: ".3"
})), 'TheatersTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TheatersTwoTone.js
// module id = 6763
// module chunks = 2